import { WithRef } from 'support/types/withRef';
import { Input } from 'components/Form/Input';

export const InputInsideCell = ({ ref, ...props }: WithRef<Parameters<typeof Input>[0], HTMLInputElement>) => (
  <Input inputWrapperClassName="h-full" wrapperClassName="size-full" {...props} ref={ref} />
);
